<div class="prod-ly-teacher-sidebar" [ngClass]="{ 'is-show': isShowSidebar }">
  <ul class="left-sidebar">
    @if (layoutService.isMediumDesktopDownView.value) {
      <li class="close" (click)="hideSidebar()"><i class="fa fa-times"></i></li>
    }
    @for (tab of appTabs; track $index; let last = $last) {
      <li [class.active]="menuTabStatus[tab.path]" [class.last]="last" [class.disable-mouse]="isCurrentRoute(tab.path)">
        @if (!tab.newTab) {
          <a [routerLink]="tab.path" [ngClass]="[tab.path === '' ? 'title' : 'item']" (click)="hideSidebar()">{{ tab.name }}</a>
        } @else {
          <a href="{{ tab.path }}" (click)="hideSidebar(); sendEvent(tab.ga4ClickParts)" target="_blank">
            <i class="fa fa-external-link item"></i>{{ tab.name }}</a
          >
        }
      </li>
    }
  </ul>
</div>
@if (slideMenuService.isShowSidebar) {
  <div [ngClass]="{ 'shadow-screen': layoutService.isMediumDesktopDownView.value }" (click)="hideSidebar()"></div>
}
